module.exports = __webpack_public_path__ + "static/Group 6846-6ece94a34a5f246a0b8905aa79b467e0.png";